import 'bootstrap';
import { ButtonPlugin } from 'bootstrap-vue/esm/components/button';
import { CardPlugin } from 'bootstrap-vue/esm/components/card';
import { DropdownPlugin } from 'bootstrap-vue/esm/components/dropdown';
import { FormInputPlugin } from 'bootstrap-vue/esm/components/form-input';
import { FormSelectPlugin } from 'bootstrap-vue/esm/components/form-select';
import { LayoutPlugin } from 'bootstrap-vue/esm/components/layout';
import { ModalPlugin } from 'bootstrap-vue/esm/components/modal';
import { ProgressPlugin } from 'bootstrap-vue/esm/components/progress';
import { SidebarPlugin } from 'bootstrap-vue/esm/components/sidebar';
import { SpinnerPlugin } from 'bootstrap-vue/esm/components/spinner';
import { TabsPlugin } from 'bootstrap-vue/esm/components/tabs';
import { TooltipPlugin } from 'bootstrap-vue/esm/components/tooltip';
import Vue from 'vue';

export function bootstrapInit() {
  Vue.use(ButtonPlugin);
  Vue.use(CardPlugin);
  Vue.use(DropdownPlugin);
  Vue.use(FormInputPlugin);
  Vue.use(FormSelectPlugin);
  Vue.use(LayoutPlugin);
  Vue.use(ModalPlugin);
  Vue.use(ProgressPlugin);
  Vue.use(SidebarPlugin);
  Vue.use(SpinnerPlugin);
  Vue.use(TabsPlugin);
  Vue.use(TooltipPlugin);
}
